import { FormattedMessage } from 'react-intl'
import {
	CheckmarkCircleIconStyled,
	FreeShippingNeeded,
	FreeShippingReached,
	Price,
} from './free-shipping-estimate.styled'

const FreeShippingEstimate = ({ threshold, amountLeft, cartItems }) => {
	return (
		<>
			{threshold === 0 || (threshold > 0 && amountLeft <= 0) ? (
				<FreeShippingReached color="success" component="div" variant="body2">
					<CheckmarkCircleIconStyled />
					<FormattedMessage id="cart_free_shipping_reached" values={{ threshold: <Price amount={threshold} /> }} />
				</FreeShippingReached>
			) : null}

			{cartItems?.length && threshold > 0 && amountLeft > 0 ? (
				<FreeShippingNeeded component="div" variant="body2">
					<FormattedMessage
						id="cart_free_shipping_needed"
						values={{
							amountLeft: <Price amount={amountLeft} />,
							threshold: <Price amount={threshold} />,
						}}
					/>
				</FreeShippingNeeded>
			) : null}
		</>
	)
}

export default FreeShippingEstimate
